import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LayoutComponent } from './/layouts/layout.component';

import { HomeComponent } from './pages/home/home.component';

import { LoginComponent } from './pages/login/login.component';
import { Error4042Component } from './pages/error-404-2/error-404-2.component';
import { Error403Component } from './pages/error-403/error-403.component';
import { Error500Component } from './pages/error-500/error-500.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';  

import { KorisniciComponent } from './pages/vimeo/korisnici/korisnici.component';
import { VideozapisiComponent } from './pages/vimeo/videozapisi/videozapisi.component';
import { PravaPristupaComponent } from './pages/vimeo/prava-pristupa/prava-pristupa.component';
import { PrijavaKorisnikComponent } from './pages/vimeo/prijava-korisnik/prijava-korisnik.component';
import { VideoPlayerComponent } from './pages/vimeo/video-player/video-player.component';

//Virtualna učionica
import { UcionicaPopisComponent } from './pages/virtualna-ucionica/ucionica-popis/ucionica-popis.component';
import { UcionicaDetaljiComponent } from './pages/virtualna-ucionica/ucionica-detalji/ucionica-detalji.component';
import { PolazniciPopisComponent } from './pages/virtualna-ucionica/polaznici-popis/polaznici-popis.component';
import { VideozapisiPopisComponent } from './pages/virtualna-ucionica/videozapisi-popis/videozapisi-popis.component';
import { DokumentiPopisComponent } from './pages/virtualna-ucionica/dokumenti-popis/dokumenti-popis.component';
import { UgovoriPopisComponent } from './pages/virtualna-ucionica/ugovori-popis/ugovori-popis.component';
import { PartneriPopisComponent } from './pages/virtualna-ucionica/partneri-popis/partneri-popis.component';
import { PredavaciPopisComponent } from './pages/virtualna-ucionica/predavaci-popis/predavaci-popis.component';
import { PolaznikUcioniceComponent } from './pages/virtualna-ucionica/polaznik-ucionice/polaznik-ucionice.component';
import { PolaznikUcionicaComponent } from './pages/virtualna-ucionica/polaznik-ucionica/polaznik-ucionica.component';
import { IshodiUcenjaComponent } from './pages/virtualna-ucionica/ishodiucenja-popis/ishodiucenja-popis.component';
import { NastavnejedinicePopisComponent } from './pages/virtualna-ucionica/nastavnejedinice-popis/nastavnejedinice-popis.component';
import { NacinpredavanjaPopisComponent } from './pages/virtualna-ucionica/nacinpredavanja-popis/nacinpredavanja-popis.component';
import { PodrucjeznanjaPopisComponent } from './pages/virtualna-ucionica/podrucjeznanja-popis/podrucjeznanja-popis.component';
import { ModuliPopisComponent } from './pages/virtualna-ucionica/moduli-popis/moduli-popis.component';
import { ZavrseneEdukacijeComponent } from './pages/virtualna-ucionica/zavrseneedukacije/zavrseneedukacije.component';
import { OtkazaneEdukacijeComponent } from './pages/virtualna-ucionica/otkazaneedukacije/otkazaneedukacije.component';
import { UvjerenjaComponent } from './pages/virtualna-ucionica/uvjerenja/uvjerenja.component';
import { IshodNastavneJedinicePopisComponent } from './pages/virtualna-ucionica/ishod-nastavnejedinice-popis/ishod-nastavnejedinice-popis.component';

const routes: Routes = [
    {path: '', redirectTo: 'login', pathMatch: 'full'},
    {
        "path": "",
        "component": LayoutComponent,
        "children": [
            {
                path: "index",
                component: HomeComponent
            },
            {
                path: "korisnici",
                component: KorisniciComponent
            },
            {
                path: "videozapisi",
                component: VideozapisiComponent
            },
            {
                path: "pravapristupa",
                component: PravaPristupaComponent
            },
            {
                path: "ucionica-popis",
                component: UcionicaPopisComponent
            },
            {
                path: "ucionica-detalji/:id",
                component: UcionicaDetaljiComponent
            },
            {
                path: "polaznici-popis",
                component: PolazniciPopisComponent
            },
            {
                path: "videozapisi-popis",
                component: VideozapisiPopisComponent
            },
            {
                path: "dokumenti-popis",
                component: DokumentiPopisComponent
            },
            {
                path: "ugovori-popis",
                component: UgovoriPopisComponent
            },
            {
                path: "partneri-popis",
                component: PartneriPopisComponent
            },
            {
                path: "predavaci-popis",
                component: PredavaciPopisComponent
            },
            {
                path: "ishodiucenja-popis",
                component: IshodiUcenjaComponent
            },
            {
                path: "nastavnejedinice-popis",
                component: NastavnejedinicePopisComponent
            },
            {
                path: "ishod-nastavnejedinice-popis",
                component: IshodNastavneJedinicePopisComponent
            },
            {
                path: "nacinpredavanja-popis",
                component: NacinpredavanjaPopisComponent
            },
            {
                path: "podrucjeznanja-popis",
                component: PodrucjeznanjaPopisComponent
            },
            {
                path: "moduli-popis",
                component: ModuliPopisComponent
            },
            {
                path: "zavrseneedukacije-popis",
                component: ZavrseneEdukacijeComponent
            },
            {
                path: "otkazaneedukacije-popis",
                component: OtkazaneEdukacijeComponent
            },
            {
                path: "uvjerenja",
                component: UvjerenjaComponent
            }
        ]
    },
    {
        "path": "login",
        "component": LoginComponent
    },
    {
        "path": "error_404-2",
        "component": Error4042Component
    },
    {
        "path": "error_403",
        "component": Error403Component
    },
    {
        "path": "error_500",
        "component": Error500Component
    },
    {
        "path": "prijavakorisnik",
        "component": PrijavaKorisnikComponent
    },
    {
        "path": "videoplayer",
        "component": VideoPlayerComponent
    },
    {
        "path": "polaznik-ucionice",
        "component": PolaznikUcioniceComponent
    },
    {
        "path": "polaznik-ucionica/:id",
        "component": PolaznikUcionicaComponent
    },
    {
        "path": "**",
        "redirectTo": "error_404-2",
        "pathMatch": "full"
    },
];

@NgModule({
  declarations: [
    HomeComponent,
    LoginComponent,
    Error4042Component,
    Error403Component,
    Error500Component
  ],
  imports: [ RouterModule.forRoot(routes, {
    useHash: true
   }),
   FormsModule,
   ReactiveFormsModule,
   CommonModule ],
  exports: [ 
    RouterModule,
  ]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// C:/Users/TomislavS/Projekti/31-Holspico-VirtualnaUcionica/VirtualnaUcionica-Web/src/app/app-routing.module.ts